import { render, staticRenderFns } from "./contentInfoList.vue?vue&type=template&id=2f9f1983&scoped=true"
import script from "./contentInfoList.vue?vue&type=script&lang=js"
export * from "./contentInfoList.vue?vue&type=script&lang=js"
import style0 from "./contentInfoList.vue?vue&type=style&index=0&id=2f9f1983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f1983",
  null
  
)

export default component.exports